import script from "./VerMovimientos.vue?vue&type=script&setup=true&lang=js"
export * from "./VerMovimientos.vue?vue&type=script&setup=true&lang=js"

import "./VerMovimientos.vue?vue&type=style&index=0&id=311542b0&lang=css"

const __exports__ = script;

export default __exports__